export class DoctorConfig {
  constructor(public userId: string, public doctorId: string) {}
}
